import { Select, MenuItem, styled, InputBase, SelectChangeEvent } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ProductType } from '@/data/types/Product';
import { useModalOutfitsContext } from '@/components/blocks/ModalOutfits/parts/OutfitsProvider';

const ProductSizeInput = styled(InputBase)({
	width: '95px !important',
	padding: '0px',
	'& .MuiInputBase-input': {
		position: 'relative',
		backgroundColor: '#FFFFFF',
		border: '1px solid #C9C9C9',
		fontSize: 'var(--font-size-small)',
		padding: '4px',
		borderRadius: '2px',
	},
	'& .MuiSelect-icon': {
		color: 'primary.main',
	},
	'&:hover': {
		backgroundColor: 'transparent',
	},
});

interface OutfitItemSizeProps {
	product: ProductType & { sizes: { partNumber: string; size: string }[] };
}

export const OutfitItemSize: React.FC<OutfitItemSizeProps> = ({ product }) => {
	const { productsSelected, onSelectChildrenProduct } = useModalOutfitsContext();

	const currentSelectedSize = productsSelected[product.partNumber] || 'talla';

	const handleOnSelectChildrenProduct = (event: SelectChangeEvent<string>) => {
		onSelectChildrenProduct(product.partNumber, event.target.value);
	};

	return (
		<Select
			value={currentSelectedSize}
			input={<ProductSizeInput />}
			IconComponent={KeyboardArrowDownIcon}
			sx={{
				height: '32px !important',
				'.MuiSelect-nativeInput': {
					padding: '0px',
				},
			}}
			MenuProps={{
				sx: {
					zIndex: 9999999999,
				},
			}}
			onChange={handleOnSelectChildrenProduct}
		>
			<MenuItem disabled value="talla">
				{'Talla'}
			</MenuItem>
			{product.sizes.map((size) => (
				<MenuItem key={size.partNumber} value={size.partNumber}>
					{size.size}
				</MenuItem>
			))}
		</Select>
	);
};
